import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import {
  getCompanyFinances,
  updateCompanyBalance
} from '../../../../store/actions/paymentsActions';

const styles = theme => ({
  currentBalance: {
    color: '#6441a4'
  },
  fundsButtonContainer: {
    marginTop: '50px'
  },
  addFundsButton: {
    backgroundColor: '#22c26e',
    color: 'white'
  },
  addFundsText: {
    marginBottom: '40px'
  },
  depositAmountInput: {
    marginBottom: '40px'
  },
  loadingSpinner: {
    position: 'absolute',
    top: '50%',
    right: '50%'
  },
  loadingOverlay: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0',
    background: 'gray',
    opacity: '.5'
  }
});

const mapStateToProps = state => {
  return {
    profile: state.firebase.profile,
    auth: state.firebase.auth,
    finances: state.finances
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getCompanyFinances: onComplete =>
      dispatch(getCompanyFinances()).then(() => {
        onComplete();
      }),
    updateCompanyBalance: (depositDetails, onComplete) =>
      dispatch(updateCompanyBalance(depositDetails)).then(() => {
        onComplete();
      })
  };
};

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  withProps(({ auth, profile }) => ({
    auth,
    profile
  })),
  withStyles(styles),
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/company/settings/payments/CompanyPaymentSettings.enhancer.js